import { httpClient, ApiResponse } from '@/utils';
import {
  DashboardEndpoints,
  IGetDashboardDataResponse,
  IGetCityStatisticResponse,
  IGetCategoryStatisticDTO,
  IGetCategoryStatisticResponse,
  IGetTrendsResponse,
  IGetCityStatisticDTO,
  IGetBuyersDataResponse,
  IAdminMainMetricsQuery,
  IAdminTopListQuery,
  IGetAdminMainMetricsResponse,
  ITopSupplierRow,
  ITopProductRow,
} from '@/models/dashboard.model';

class DashboardAPI {
  static getDashboardData(): ApiResponse<IGetDashboardDataResponse> {
    return httpClient.get<IGetDashboardDataResponse>(DashboardEndpoints.DASHBOARD);
  }

  static getMainMetrics(params: IAdminMainMetricsQuery = {}): ApiResponse<IGetAdminMainMetricsResponse> {
    return httpClient.get<IGetAdminMainMetricsResponse>(DashboardEndpoints.DASHBOARD_MAIN_METRICS, {
      params,
    });
  }

  static getCityStatisticData(data: IGetCityStatisticDTO): ApiResponse<IGetCityStatisticResponse> {
    return httpClient.get<IGetCityStatisticResponse>(DashboardEndpoints.DASHBOARD_SETTLEMENT_STATS, {
      params: data,
    });
  }

  static getBuyersData(data: IGetCityStatisticDTO): ApiResponse<IGetBuyersDataResponse> {
    return httpClient.get<IGetBuyersDataResponse>(DashboardEndpoints.DASHBOARD_BUYERS_STATS, {
      params: data,
    });
  }

  static getCategoryStatisticData(data: IGetCategoryStatisticDTO): ApiResponse<IGetCategoryStatisticResponse> {
    return httpClient.get<IGetCategoryStatisticResponse>(DashboardEndpoints.DASHBOARD_CATEGORY_STATS, {
      params: data,
    });
  }

  static getTrends(): ApiResponse<IGetTrendsResponse> {
    return httpClient.get<IGetTrendsResponse>(DashboardEndpoints.DASHBOARD_TRENDS);
  }

  static getTopSuppliers(params: IAdminTopListQuery = {}): ApiResponse<{ data: ITopSupplierRow[] }> {
    return httpClient.get<{ data: ITopSupplierRow[] }>(DashboardEndpoints.DASHBOARD_MAIN_METRICS_TOP_SUPPLIERS, {
      params,
    });
  }

  static getTopProducts(params: IAdminTopListQuery = {}): ApiResponse<{ data: ITopProductRow[] }> {
    return httpClient.get<{ data: ITopProductRow[] }>(DashboardEndpoints.DASHBOARD_MAIN_METRICS_TOP_PRODUCTS, {
      params,
    });
  }
}

export default DashboardAPI;
